import React, { Component } from 'react';

import { ReactComponent as Logo } from './../../assets/img/logo-loading.svg';

class GlobalLoading extends Component{
  constructor(){
    super();
    
    this.state = {
      // focus: false,
    }

    // this.onFocus = this.onFocus.bind(this);
  }

  componentDidMount(){}

  componentDidUpdate(prevProps, prevState){
    // if(this.props.mapBounds !== prevProps.mapBounds){
    //   this.mapRef.current.fitBounds(this.props.mapBounds);
    // }
  }

  componentWillUnmount(){}

  renderLoading(text){
    return(
      <div className="loading-page">
        <Logo />
        {text}{text ? '...' : ''}
      </div>
    );
  }
  
  render(){
    const { text, fullPage, table } = this.props;

    if(fullPage || table){
      return(
        <div className={fullPage ? 'full-page' : table ? 'loading-table' : ''}>
          {this.renderLoading(text)}
        </div>
      );
    }else{
      return(this.renderLoading(text));
    }
  }
}

export default GlobalLoading;